// extracted by mini-css-extract-plugin
export var actionButton = "_7y-0";
export var attachmentLine = "_7y-1";
export var fileInput = "_7y-2";
export var fileUploadWrapper = "_7y-4";
export var footer = "_7y-3";
export var modalContent = "_7y-5";
export var paperclip = "_7y-6";
export var quillEditor = "_7y-7";